import { ErrorApi } from '../../api';

/**
 * Lo que dejó el último 429 o 503: mientras dure, no se pregunta.
 *
 * Vive aparte porque lo usan los dos chats —la pestaña y el flotante— y tienen
 * que leer los avisos del proxy exactamente igual.
 */
export interface Pausa {
  tipo: 'espera' | 'fuera_de_servicio' | 'no_disponible';
  mensaje: string;
  /** Instante hasta el que dura. Null en «no disponible»: se reintenta a mano. */
  hasta: number | null;
}

/** Un 503 cuyo `Retry-After` pasa de esto es el tope diario, no una caída. */
const UNA_HORA_S = 3600;

/** El 429 y el 503 detienen las preguntas un rato; lo demás es un error de esa pregunta. */
export function pausaDe(e: unknown): Pausa | null {
  if (!(e instanceof ErrorApi)) return null;
  if (e.estado === 429) {
    return { tipo: 'espera', mensaje: e.message, hasta: Date.now() + (e.reintentarEnS ?? 60) * 1000 };
  }
  if (e.estado === 503 && e.reintentarEnS !== null && e.reintentarEnS >= UNA_HORA_S) {
    return { tipo: 'fuera_de_servicio', mensaje: e.message, hasta: Date.now() + e.reintentarEnS * 1000 };
  }
  if (e.estado === 503) return { tipo: 'no_disponible', mensaje: e.message, hasta: null };
  return null;
}
